<ng-container *ngLet="loadingData$ | async as loadingData">
    <div class="accordion-wrapper">
        <mat-accordion *ngLet="data$ | async as items"
                       [multi]="true"
                       data-cy="user-permission-list">
            <ng-container *ngIf="items.length; else noUserPermissions">
                <ng-container *ngFor="let item of items;">
                    <mat-expansion-panel [expanded]="false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div *ngLet="(
                                 item.folder
                                    ? item.folder.displayName
                                    : ( 'check_perms_modal_tenant_roles_placeholder' | translate)
                                ) as folderName"
                                     class="title">
                                    <mat-icon *ngIf="item.folder; else tenant">folder_open</mat-icon>
                                    <ng-template #tenant>
                                        <mat-icon [svgIcon]="'uipath:tenant'"></mat-icon>
                                    </ng-template>
                                    <span [matTooltip]="item.folder?.fullyQualifiedName || folderName"
                                          class="folder-name">{{ folderName }}</span>
                                </div>
                            </mat-panel-title>

                            <ng-container *ngLet="(item.folder ? item.roles : item).length as count">
                                <mat-panel-description *ngIf="count > 1; else singleRole"
                                                       [translateParams]="{
                                                count: count
                                           }"
                                                       translate>
                                    check_perms_modal_roles_count
                                </mat-panel-description>
                            </ng-container>

                            <ng-template #singleRole>
                                <mat-panel-description *ngLet="(item.folder ? item.roles : item)[0] as role">
                                    <ng-container *ngIf="role.name; else tenantInherit">
                                        {{role.name}}
                                    </ng-container>
                                </mat-panel-description>
                            </ng-template>
                        </mat-expansion-panel-header>

                        <div *ngLet="(item.folder ? item.roles : item) as roles"
                             class="roles-list">
                            <div *ngFor="let role of roles"
                                 class="role">
                                <ng-container *ngTemplateOutlet="role.name ? knownRole : tenantInherit; context: {
                                    $implicit: role
                                }">
                                </ng-container>
                            </div>

                            <span *ngIf="!roles || !roles.length"
                                  translate>
                                check_perms_modal_no_roles
                            </span>
                        </div>
                    </mat-expansion-panel>
                </ng-container>
            </ng-container>
        </mat-accordion>

        <div *ngIf="loadingData"
             class="loading-data">
            <mat-spinner [diameter]="20"
                         [strokeWidth]="2">
            </mat-spinner>
        </div>
    </div>

    <ng-template #tenantInherit
                 let-role>
        <ng-container *ngIf="role && role.source[0].isInherited; else nonAD">
            {{ 'check_perms_modal_inherited_from_tenant_ad_group' | translate: { adGroup: role.source[0]?.username } }}
        </ng-container>
        <ng-template #nonAD>
            {{ 'check_perms_modal_inherited_from_tenant' | translate }}
        </ng-template>
    </ng-template>

    <ng-template #knownRole
                 let-role>
        {{role.name}} ({{formatRoleSources(role.source)}})
    </ng-template>

    <ng-template #noUserPermissions>
        <div *ngIf="!loadingData">
            {{ 'check_perms_modal_no_roles' | translate }}
        </div>
    </ng-template>
</ng-container>
